import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { AppDashboardContainerComponent } from './app-dashboard-container/app-dashboard-container.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';

const routes: Routes = [
  {
    path: 'app-dashboards',
    canActivate: [AuthorizeGuard], //RightsGuard
    component: AppDashboardContainerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppDashboardRoutingModule {}
